import { Country, User } from '@abiglobalhealth/go-types'
import * as Sentry from '@sentry/browser'
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useEffect, useState } from 'react'

export interface UserContextProps {
  user: User | null
  setUser: Dispatch<SetStateAction<User | null>>
}

export const UserContext = createContext({} as UserContextProps)

export const UserProvider = ({ children }: PropsWithChildren) => {
  const [user, setUser] = useState<UserContextProps['user']>(null)

  useEffect(() => {
    if (!user) return

    Sentry.setUser({
      uniqueId: user?.data?.uniqueId,
      userId: user?.data?.userId,
      language: user?.data?.language,
      routeConditions: user.routeConditions
    })

    Sentry.setTags({
      uniqueId: user?.data?.uniqueId
    })

    localStorage.setItem('user', JSON.stringify(user))
  }, [user])

  useEffect(() => {
    const lsUser = localStorage.getItem('user')
    const userObj: User = lsUser ? JSON.parse(lsUser) : {}

    const country = new URLSearchParams(window.location.search).get('country') || undefined
    const countryObj = {
      code: country
    } as Country

    setUser({
      ...userObj,
      data: {
        ...userObj.data,
        country: userObj?.data?.country || (country ? countryObj : undefined)
      }
    })
  }, [])

  const value = {
    user,
    setUser
  }

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>
}
